<div class="modals--sign" [ngClass]="'mis-datos--modal'">
  <div class="modals--sign--title mb-5">
    <h1 class="xl-serif-bold">{{ documentType }}</h1>
    <div class="s-regular">
      <div class="mb-2">
        {{ 'sign.header.notificationDate' | translate }}: {{ generationDate | date: 'dd/MM/yyyy' }}
      </div>
    </div>
    <div class="modals--sign--signatureStatus mt-3">
      {{ obtenerFirma(signatureStatus) | translate }}
    </div>
  </div>

  <div class="modals--sign--download-button">
    <button
      pButton
      (click)="downloadFile(documentId)"
      (keyup.enter)="downloadFile(documentId)"
      class="medium-40">
      <app-cigna-icon icon="download"></app-cigna-icon>
      <span>{{ 'sign.accept.download' | translate }}</span>
    </button>
  </div>
  <br />

  <div class="flex flex-column justify-content-left gap-5 w-full">
    @if (signature === 'ACCEPT' && !!acceptanceNeeded) {
      <div name="detalleseleccion">
        <div class="flex flex-wrap justify-content-left gap-4 w-full">
          <div class="flex-1 modals--sign--acceptone">
            <div class="modals--sign--acceptone--letra s-regular">
              {{ 'sign.header.read' | translate }}
              <span
                tabindex="2"
                (click)="showTerms('ACCEPT')"
                (keyup.enter)="showTerms('ACCEPT')"
                class="modals--sign--texto--name">
                {{ 'sign.header.advise' | translate }}
              </span>
              {{ 'sign.header.click' | translate }}
            </div>
            <p-inputSwitch
              [disabled]="!termsAccept"
              [(ngModel)]="checkedAccept"
              class="modals--sign--acceptone--boton" />
          </div>
        </div>
      </div>

      @if (showErrorAccept) {
        <div class="flex flex-column justify-content-left gap-5 w-full mt-3">
          <div class="flex flex-wrap justify-content-left gap-4 w-full">
            <div class="flex-1 modals--sign--acceptone">
              <div class="modals--sign--error s-regular">
                <span>{{ 'sign.header.error' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="modals--sign--paginator w-full flex justify-content-right mt-2">
        <button pButton class="mt-4" (click)="aceptar()" [disabled]="false">
          <app-cigna-icon icon="save"></app-cigna-icon>{{ 'sign.accept.button' | translate }}
        </button>
      </div>
    }

    @if (signature === 'SIGN' && !!signNeeded) {
      <div class="modals--sign--dudas-registro">
        <p-accordion
          [(activeIndex)]="activeTabIndex"
          class="modals--sign--dudas-registro--accordion">
          <p-accordionTab
            [header]="'sign.hardSign.online' | translate"
            (click)="onAccordionOpen(1)">
            <app-file-attach-field
              title="sign.hardSign.documentation"
              subtitle="sign.hardSign.onlineDescription"
              badgeLabel="solicitud_reembolso.documentacion.obligatorio"
              badgeClass="form-fields--file-attach--badge--required destacado-error-border"
              appButtonLabel="sign.hardSign.attach"
              selectFileLabel="solicitud_reembolso.documentacion.select_file"
              dropzoneTitle="solicitud_reembolso.documentacion.dropzone_title"
              formatHint="sign.hardSign.sizeLimitPdf"
              [files]="attachedFiles"
              [accept]="fileAttachAccept"
              inputId="loadDoc"
              [enableReorder]="false"
              [showUploadOnlyWhenEmpty]="true"
              (filesSelected)="onFilesReceived($event)"
              (filesRejected)="onFilesRejected()"
              (fileRemoved)="deleteFile()"
              (appUploadRequested)="signAttachInput.click()" />
            <label for="signAttachInput" class="sr-only">
              {{ 'sign.hardSign.attach' | translate }}
            </label>
            <input
              #signAttachInput
              id="signAttachInput"
              type="file"
              class="hidden"
              [accept]="fileAttachAccept"
              (change)="onFileSelected($event)" />

            @if (showFileError) {
              <div class="flex flex-column justify-content-left gap-5 w-full">
                <div class="flex flex-wrap justify-content-left gap-4 w-full">
                  <div class="flex-1 modals--sign--acceptone">
                    <div
                      class="modals--sign--acceptone--letra s-regular modals--sign--error w-full mb-2">
                      {{ 'sign.header.documentError' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            }

            <div name="detalleseleccion">
              <div class="flex flex-wrap justify-content-left gap-4 w-full">
                <div class="flex-1 modals--sign--acceptone">
                  <div class="modals--sign--acceptone--letra s-regular">
                    {{ 'sign.header.read' | translate }}
                    <span
                      tabindex="2"
                      (click)="showTerms('SIGN')"
                      (keyup.enter)="showTerms('SIGN')"
                      class="modals--sign--texto--name">
                      {{ 'sign.header.advise' | translate }}
                    </span>
                    {{ 'sign.header.click' | translate }}
                  </div>
                  <p-inputSwitch [disabled]="!terms" [(ngModel)]="checked" />
                </div>
              </div>
            </div>

            @if (showError) {
              <div class="flex flex-column justify-content-left gap-5 w-full mt-3">
                <div class="flex flex-wrap justify-content-left gap-4 w-full">
                  <div class="flex-1 flex destacado-error-border modals--sign--error">
                    <div
                      class="flex align-items-center justify-content-center modals--sign--error--icon mr-2">
                      <app-cigna-icon icon="banned"></app-cigna-icon>
                    </div>
                    <div class="flex s-regular">
                      <span>{{ 'sign.header.error' | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            }

            <div class="modals--sign--paginator w-full flex justify-content-right mt-2">
              <button pButton class="mt-4" (click)="firmar()" [disabled]="false">
                <app-cigna-icon icon="save"></app-cigna-icon>
                {{ 'sign.hardSign.button' | translate }}
              </button>
            </div>
          </p-accordionTab>
        </p-accordion>

        <p-accordion
          [(activeIndex)]="secondActiveTabIndex"
          class="modals--sign--dudas-registro--accordion">
          <p-accordionTab
            [header]="'sign.hardSign.postal' | translate"
            (click)="onAccordionOpen(2)">
            <div class="mt-3" innerHtml="{{ 'sign.hardSign.postalOption' | translate }}"></div>
            <div class="mt-4" innerHtml="{{ 'sign.hardSign.cigna_title' | translate }}"></div>
            <div innerHtml="{{ 'sign.hardSign.cigna_subtitle' | translate }}"></div>
            <div class="oncampus--container--paginator w-full flex justify-content-right mt-2">
              <button pButton class="mt-4" (click)="firmarPostal()" [disabled]="false">
                {{ 'sign.hardSign.postalWay' | translate }}
              </button>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
    }
  </div>
</div>
